import React from 'react'
import NavigationPrompt from 'react-router-navigation-prompt'
import Modal from 'react-bootstrap/cjs/Modal'
import styled from 'styled-components'
import { colors } from 'utils'
import Button from './Button'

const S = {
    ModalHeader: styled(Modal.Header)`
        position: relative;
        padding: 30px;
        font-weight: 500;
        font-size: 30px;
        line-height: 35px;
        color: ${colors.dark};
        border-bottom: none;
        & button {
            position: absolute;
            top: 18px;
            right: 30px;
            color: ${colors.icon};
            font-size: 34px;
            font-weight: 400;
            opacity: 1 !important;
        }
    `,
    ModalBody: styled(Modal.Body)`
        padding: 0 30px 40px 30px;
        font-weight: 300;
        font-size: 16px;
        line-height: 19px;
        color: ${colors.grayDescription};
    `,
    ModalFooter: styled(Modal.Footer)`
        padding: 0 30px 20px 30px;
        display: flex;
        justify-content: space-between;
        border-top: none;
    `
}

interface Props {
    when: boolean | ((crntLocation, nextLocation) => boolean)
    title?: string
    confirmText: string
    saveText?: string
    discardText?: string
    cancelText?: string
    submitAction?: (e?: React.FormEvent<HTMLFormElement>) => void
}
const RouteLeavingPrompt = ({
    when,
    title = 'Attention',
    confirmText,
    submitAction = () => null,
    saveText = 'Save',
    discardText = 'Discard',
    cancelText = 'Cancel',
}: Props) => {
    const [show, setShow] = React.useState(true)
    const close = (onCancel) => {
        setShow(false)
        setTimeout(() => {
            onCancel()
            setShow(true)
        }, 250)
    }

    const handleSave = (onCancel) => {
        setShow(false)
        onCancel()
        setShow(true)
        submitAction()
    }

    const handleDiscard = (onConfirm) => {
        setShow(false)
        onConfirm()
    }

    return (
        <NavigationPrompt when={when}>
            {({ onConfirm, onCancel }) => (
                <Modal centered show={show} onHide={() => close(onCancel)}>
                    <S.ModalHeader closeButton>
                        {title}
                    </S.ModalHeader>
                    <S.ModalBody>
                        {confirmText}
                    </S.ModalBody>
                    <S.ModalFooter>
                        <Button onClick={() => close(onCancel)} variant="secondary">
                            {cancelText}
                        </Button>
                        <div>
                            <Button onClick={() => handleDiscard(onConfirm)} variant="danger">
                                {discardText}
                            </Button>
                            <Button
                                onClick={() => handleSave(onCancel)}
                                variant="primary"
                                style={{ marginLeft: 10 }}
                            >
                                {saveText}
                            </Button>
                        </div>
                    </S.ModalFooter>
                </Modal>
            )}
        </NavigationPrompt>
    )
}
export default RouteLeavingPrompt
